import { useSelector } from 'react-redux';
import { isMobileLayout } from 'components/Shared/responsive';
import styles from './imageRow.scss';
import { getGetImageUrl } from 'services/ApiKnowledgebaseService';
import { Reducer, useEffect, useReducer } from 'react';

interface ImageRowProps {
  caption01: string;
  image01: string;
  caption02: string;
  image02: string;
  caption03: string;
  image03: string;
  caption04: string;
  image04: string;
  caption05: string;
  image05: string;
}

export const ImageRow = ({
  caption01,
  image01,
  caption02,
  image02,
  caption03,
  image03,
  caption04,
  image04,
  caption05,
  image05
}: ImageRowProps) => {
  const mobile = useSelector(isMobileLayout);

  const images = [
    { image: image01, text: caption01 },
    { image: image02, text: caption02 },
    { image: image03, text: caption03 },
    { image: image04, text: caption04 },
    { image: image05, text: caption05 }
  ].filter(img => img.image.length > 0);

  return (
    <div className={styles.imageRow}>
      {images.map(({ image, text }, i) => (
        <div key={i} className={styles.image}>
          <div className={styles.image}>
            <Image image={image} numberOfImages={images.length} />
            <div
              className={styles.text}
              style={getTextStyle({ numberOfImages: images.length, isMobile: mobile })}
            >
              {text}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

interface ImageProps {
  image: string;
  numberOfImages: number;
}

interface ImageState {
  image: string;
}

const initialImageState: ImageState = {
  image: ''
};

type ImageAction = { type: 'image'; value: string };

const imageReducer: Reducer<ImageState, ImageAction> = (state, action) => {
  switch (action.type) {
    case 'image': {
      return { ...state, image: action.value };
    }
    default:
      return state;
  }
};

const Image = ({ image, numberOfImages }: ImageProps) => {
  const [state, dispatch] = useReducer(imageReducer, initialImageState);
  const mobile = useSelector(isMobileLayout);

  useEffect(() => {
    void getGetImageUrl(image).then(response => {
      dispatch({ type: 'image', value: response.url });
    });
  }, [image]);

  return (
    <div
      className={styles.img}
      style={getImageStyle({
        image: state.image,
        numberOfImages: numberOfImages,
        isMobile: mobile
      })}
    />
  );
};

const getImageStyle = ({
  image,
  numberOfImages,
  isMobile
}: {
  image: string;
  numberOfImages: number;
  isMobile: boolean;
}) => {
  const style = {
    backgroundImage: `url(${image})`
  };

  if (!isMobile) {
    return {
      ...style,
      height: getImageHeight({ numberOfImages })
    };
  }

  return style;
};

const getImageHeight = ({ numberOfImages }: { numberOfImages: number }) => {
  switch (numberOfImages) {
    case 2:
      return '27.5rem';
    case 3:
      return '18rem';
    case 4:
      return '13rem';
    case 5:
      return '10rem';
    default:
      return 0;
  }
};

const getTextStyle = ({
  numberOfImages,
  isMobile
}: {
  numberOfImages: number;
  isMobile: boolean;
}) => {
  if (isMobile) {
    return {};
  }

  return { fontSize: getFontSize({ numberOfImages }) };
};

const getFontSize = ({ numberOfImages }: { numberOfImages: number }) => {
  switch (numberOfImages) {
    case 2:
      return '1.4rem';
    case 3:
      return '1.2rem';
    case 4:
      return '1.1rem';
    case 5:
      return '1rem';
    default:
      return 0;
  }
};
